<template>
  <div class="page">
    <div class="navbar"><h1>项目列表</h1></div>

    <div class="pj-tabs">
      <div
        v-for="t in tabs"
        :key="t.key"
        class="pj-tab"
        :class="{ active: currentStatus === t.key }"
        @click="selectStatus(t.key)"
      >
        {{ t.label }} {{ counts[t.key] }}
      </div>
    </div>

    <div class="scroll page-pad">
      <div v-if="loading" class="m-loading"><span class="spin"></span><p>加载中…</p></div>
      <template v-else>
        <div v-if="projects.length === 0" class="empty">
          <svg viewBox="0 0 120 120" fill="none">
            <rect x="18" y="26" width="84" height="74" rx="8" fill="#eef1f5"/>
            <rect x="30" y="14" width="60" height="20" rx="6" fill="#dfe4ea"/>
            <rect x="32" y="46" width="42" height="6" rx="3" fill="#d9dfe6"/>
            <rect x="32" y="62" width="56" height="6" rx="3" fill="#e4e9ee"/>
            <rect x="32" y="78" width="34" height="6" rx="3" fill="#e4e9ee"/>
          </svg>
          <p>暂无该状态的项目</p>
        </div>

        <div
          v-for="p in projects"
          :key="p.id"
          class="pj-card"
          @click="$router.push('/m/order?pid=' + p.id + '&pname=' + encodeURIComponent(p.name))"
        >
          <div class="pj-hd">
            <span class="nm">{{ p.name }}</span>
            <span class="tag" :style="{ color: statusColor(p.status), background: statusBg(p.status) }">
              {{ statusLabel(p.status) }}
            </span>
          </div>
          <div class="pj-period">
            <div class="pr"><span>开始时间</span><b>{{ p.startDate }}</b></div>
            <div class="pr"><span>结束时间</span><b>{{ p.endDate }}</b></div>
          </div>
          <div class="pj-nums">
            <div class="nu"><b>{{ p.orderCount }}</b><span>订单总数</span></div>
            <div class="nu g"><b>{{ p.reportCount }}</b><span>报告数量</span></div>
          </div>
        </div>
      </template>
    </div>
    <m-tab-bar/>
  </div>
</template>

<script>
import MTabBar from './MTabBar.vue';
import mobileRem from '@/commonJs/mobileRem';
import ApiService from '@/service/ApiService';
import pub from '@/service/public';

export default {
  name: 'MProject',
  components: {
    MTabBar
  },
  mixins: [mobileRem],
  data() {
    return {
      tabs: [],
      projectStatusMap: {},
      counts: {},
      loading: false,
      currentStatus: 'all',
      projects: [],   // 当前 tab 过滤后的列表
      allProjects: [] // 服务端返回的全量列表（status=-1）
    }
  },
  mounted() {
    this.initConstOptions()
    this.loadData()
  },
  methods: {
    initConstOptions() {
      const constData = pub.getConst()
      if (constData && Array.isArray(constData.projectStatus)) {
        // 与 PC 端一致：直接使用服务器返回的项目状态
        // 构建状态映射：value -> {label, color, bg}
        this.projectStatusMap = {}
        
        constData.projectStatus.forEach(item => {
          const value = Number(item.value)
          this.projectStatusMap[value] = {
            label: item.name || '未知',
            color: this.projectPill(value).color,
            bg: this.projectPill(value).bg
          }
        })
        
        // 构建标签页：全部 + 所有服务器返回的状态
        this.tabs = [
          {key: -1, label: '全部', color: '#5b6472', bg: '#f1f3f6'}
        ]
        
        // 按服务器返回的顺序添加状态标签
        constData.projectStatus.forEach(item => {
          const pill = this.projectPill(item.value)
          this.tabs.push({
            key: Number(item.value),
            label: item.name,
            color: pill.color,
            bg: pill.bg
          })
        })
        
        // 设置默认状态为 进行中
        this.currentStatus = 400
        
        // 初始化计数
        this.counts = {}
        this.tabs.forEach(t => {
          this.counts[t.key] = 0
        })
      } else {
        // 兜底
        this.tabs = [
          {key: -1, label: '全部', color: '#5b6472', bg: '#f1f3f6'},
          {key: 400, label: '进行中', color: '#1c765f', bg: '#e0f2ea'},
          {key: 300, label: '已完成', color: '#2c6bb8', bg: '#e3f0ff'},
          {key: 500, label: '已结束', color: '#bd6b6b', bg: '#fae9e9'}
        ]
        this.currentStatus = -1
        this.counts = {}
        this.counts[-1] = 0
        this.counts[400] = 0
        this.counts[300] = 0
        this.counts[500] = 0
      }
    },
    selectStatus(status) {
      if (status === this.currentStatus) return
      this.currentStatus = status
      this.refreshView()
    },
    loadData() {
      this.loading = true
      const params = {
        page: {number: 0, limit: 500},
        keyWord: [],
        parms: {status: -1}
      }
      ApiService.ManagerProjectList(params, 'mobile')
        .then(res => {
          if (res && res.code === pub.backCode.SUCCESS && res.data) {
            const list = (res.data.pageList || []).map(p => this.mapProject(p))
            this.allProjects = list
            this.refreshView()
          } else {
            this.allProjects = []
            this.projects = []
            this.resetCounts()
            if (res) pub.analysisReturnCode(res, null)
          }
        })
        .catch(error => {
          console.error('获取项目列表失败：', error)
          this.allProjects = []
          this.projects = []
          this.resetCounts()
        })
        .finally(() => {
          this.loading = false
        })
    },
    refreshView() {
      this.projects = this.currentStatus === -1
        ? this.allProjects
        : this.allProjects.filter(p => p.status === this.currentStatus)

      this.counts = {}
      this.tabs.forEach(t => {
        if (t.key === -1) {
          this.counts[t.key] = this.allProjects.length
        } else {
          this.counts[t.key] = this.allProjects.filter(p => p.status === t.key).length
        }
      })
    },
    resetCounts() {
      this.counts = {}
      this.tabs.forEach(t => {
        this.counts[t.key] = 0
      })
    },
    mapProject(p) {
      return {
        id: p.projectUuid || p.uuid || p.projectId || p.projectName,
        name: p.projectName,
        startDate: this.fmtDate(p.startTime),
        endDate: this.fmtDate(p.endTime),
        status: p.status,
        orderCount: p.orderCount || 0,
        reportCount: p.orderReportCount || 0
      }
    },
    fmtDate(ts) {
      if (ts === null || ts === undefined || ts === '' || Number(ts) === 0) return ''
      const d = new Date(Number(ts) * 1000)
      if (isNaN(d.getTime())) return ''
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const dd = String(d.getDate()).padStart(2, '0')
      return `${y}-${m}-${dd}`
    },
    projectPill(value) {
      const n = Number(value)
      // 与 PC ProjectList 的 .pill-active / .pill-approved / .pill-ended 完全一致的配色
      if (n === 400) return {color: '#1c765f', bg: '#e0f2ea'}   // 进行中
      if (n === 300) return {color: '#2c6bb8', bg: '#e3f0ff'}   // 已完成/已审核
      return {color: '#bd6b6b', bg: '#fae9e9'}                  // 未开始/已结束等
    },
    statusLabel(s) {
      const statusItem = this.projectStatusMap[Number(s)]
      if (statusItem) {
        return statusItem.label
      }
      const tab = this.tabs.find(t => t.key === Number(s))
      return tab ? tab.label : '未知'
    },
    statusColor(s) {
      return this.projectPill(s).color
    },
    statusBg(s) {
      return this.projectPill(s).bg
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent
}

.page {
  --primary: #12b3a8;
  --primary-d: #0d9b91;
  --primary-l: #e8f8f6;
  --success: #16b364;
  --success-l: #e7f8ef;
  --t1: #14181f;
  --t2: #5b6472;
  --t3: #9aa4b2;
  --line: #eef0f4;
  --bg: #f4f6f8;
  --card: #fff;
  font-size: 14px;
  line-height: normal;
  -webkit-text-size-adjust: 100%;
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
  background: var(--bg);
  display: flex;
  flex-direction: column
}

.navbar {
  height: 46px;
  flex: none;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border-bottom: .5px solid rgba(0, 0, 0, .15)
}

.navbar h1 {
  font-size: 17px;
  font-weight: 600;
  color: var(--t1)
}

.pj-tabs {
  flex: none;
  background: #fff;
  display: flex;
  gap: 8px;
  padding: 12px 10px;
  border-bottom: .5px solid var(--line)
}

.pj-tab {
  flex: 1;
  height: 32px;
  border-radius: 16px;
  font-size: 13px;
  color: var(--t2);
  background: var(--bg);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer
}

.pj-tab.active {
  background: var(--primary);
  color: #fff;
  font-weight: 600
}

.scroll {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: calc(56px + env(safe-area-inset-bottom))
}

.page-pad {
  padding: 0 12px 12px;
  margin-top: 10px;
}

.pj-card {
  background: #fff;
  border-radius: 14px;
  padding: 13px 14px;
  margin-bottom: 10px;
  box-shadow: 0 2px 10px rgba(20, 24, 31, .05);
  cursor: pointer
}

.pj-hd {
  display: flex;
  align-items: flex-start;
  gap: 10px
}

.pj-hd .nm {
  font-size: 15px;
  font-weight: 600;
  color: var(--t1);
  flex: 1;
  line-height: 1.4
}

.pj-hd .tag {
  padding: 3px 8px;
  border-radius: 5px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  flex: none;
  margin-top: 1px
}

.pj-period {
  margin-top: 9px
}

.pj-period .pr {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 13px;
  padding: 4px 0
}

.pj-period .pr span {
  font-size: 12px;
  color: var(--t3)
}

.pj-period .pr b {
  font-weight: 500;
  color: var(--t1);
  font-family: ui-monospace, Menlo, Consolas, monospace
}

.pj-nums {
  display: flex;
  margin-top: 9px;
  padding-top: 11px;
  border-top: 1px solid var(--line)
}

.pj-nums .nu {
  flex: 1;
  text-align: center;
  border-right: 1px solid var(--line)
}

.pj-nums .nu:last-child {
  border-right: none
}

.pj-nums .nu b {
  display: block;
  font-size: 18px;
  font-weight: 700;
  color: var(--t1);
  line-height: 1.3
}

.pj-nums .nu span {
  font-size: 11.5px;
  color: var(--t3);
  line-height: 1.5;
  margin-top: 2px
}

.pj-nums .nu.g b {
  color: var(--success)
}

.skeleton {
  padding: 0
}

.sk-card {
  height: 130px;
  background: linear-gradient(90deg, #f1f3f6 25%, #eef0f4 50%, #f1f3f6 75%);
  background-size: 200% 100%;
  animation: shimmer 1.2s infinite;
  border-radius: 14px;
  margin-bottom: 12px
}

@keyframes shimmer {
  0% {
    background-position: 200% 0
  }
  100% {
    background-position: -200% 0
  }
}

/* 空态（与原型一致） */
.empty {
  padding: 70px 20px;
  text-align: center
}
.empty svg {
  width: 96px;
  height: 96px;
  opacity: .5
}
.empty p {
  color: var(--t3);
  font-size: 13.5px;
  margin-top: 12px
}
/* 列表加载态 */
.m-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 90px 0;
  gap: 12px;
  color: var(--t3)
}

.m-loading .spin {
  width: 26px;
  height: 26px;
  border: 2.5px solid #d8dde5;
  border-top-color: var(--primary);
  border-radius: 50%;
  animation: spin .7s linear infinite
}

.m-loading p {
  font-size: 13px
}

@keyframes spin {
  to {
    transform: rotate(360deg)
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/MProject.vue